import { ActionType, createAsyncAction } from 'typesafe-actions'
import { CampaignState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchManyByCampaignIdsAction = createAsyncAction(
  '@campaign/FETCH_MANY_BY_CAMPAIGN_IDS_REQUEST',
  '@campaign/FETCH_MANY_BY_CAMPAIGN_IDS_SUCCESS',
  '@campaign/FETCH_MANY_BY_CAMPAIGN_IDS_FAILURE'
)<Request, Success, Failure>()

const request = (state: CampaignState): CampaignState => ({
  ...state,
  isLoadingFetchManyByCampaignIds: true
})

const success = (
  state: CampaignState,
  action: ActionType<typeof fetchManyByCampaignIdsAction.success>
): CampaignState => {
  return {
    ...state,
    campaignsByAttend: action.payload.campaigns,
    isSuccessFetchManyByCampaignIds: true,
    isLoadingFetchManyByCampaignIds: false
  }
}

const failure = (state: CampaignState): CampaignState => {
  return {
    ...state,
    isLoadingFetchManyByCampaignIds: false,
    isErrorFetchManyByCampaignIds: true
  }
}

export const fetchManyByCampaignIdsHandle = {
  asyncAction: fetchManyByCampaignIdsAction,
  request,
  success,
  failure
}
